import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { CATEGORY_LABEL, RISK_CLASS, RISK_LABEL, fmtTimeAgo } from "@/lib/labels";

export default function Cases() {
  const [items, setItems] = useState([]);
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(true);
  const nav = useNavigate();

  useEffect(() => {
    const q = status ? `?status=${status}` : "";
    setLoading(true);
    api.get(`/cases${q}`).then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, [status]);

  const statuses = ["", "new", "triaged", "in_progress", "waiting_internal", "waiting_customer", "resolved", "closed"];

  return (
    <div className="px-4 py-5 md:px-8 md:py-6">
      <div className="mb-4">
        <div className="text-[11px] uppercase tracking-[0.18em] mb-1" style={{ color: "var(--text-muted)" }}>Case Engine</div>
        <h1 className="font-display text-[24px]">Cases</h1>
      </div>

      <div className="flex flex-wrap items-center gap-1.5 mb-3">
        {statuses.map((s) => (
          <button key={s || "all"} data-testid={`case-status-${s || "all"}`}
                  onClick={() => setStatus(s)}
                  className={`px-3 py-1.5 rounded-md text-[12px] border ${status === s ? "chip-selected" : ""}`}
                  style={status === s ? {} : { background: "var(--surface)", borderColor: "var(--border)", color: "var(--text-secondary)" }}>
            {s ? s.replace(/_/g, " ") : "All"}
          </button>
        ))}
      </div>

      <div className="card overflow-x-auto" data-testid="cases-table">
        <table className="w-full min-w-[640px] text-[12.5px]">
          <thead>
            <tr className="text-left" style={{ color: "var(--text-muted)", borderBottom: "1px solid var(--border)" }}>
              <th className="py-2 px-3 font-medium text-[11px] uppercase tracking-wider">Ref</th>
              <th className="py-2 px-3 font-medium text-[11px] uppercase tracking-wider">Title</th>
              <th className="py-2 px-3 font-medium text-[11px] uppercase tracking-wider">Customer</th>
              <th className="py-2 px-3 font-medium text-[11px] uppercase tracking-wider">Risk</th>
              <th className="py-2 px-3 font-medium text-[11px] uppercase tracking-wider">Category</th>
              <th className="py-2 px-3 font-medium text-[11px] uppercase tracking-wider">Status</th>
              <th className="py-2 px-3 font-medium text-[11px] uppercase tracking-wider">Attention</th>
              <th className="py-2 px-3 font-medium text-[11px] uppercase tracking-wider">SLA</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={8} className="py-10 text-center" style={{ color: "var(--text-muted)" }}>Loading cases…</td></tr>}
            {!loading && items.map((c) => (
              <tr key={c.id}
                  data-testid={`case-row-${c.case_ref}`}
                  onClick={() => nav(`/cases/${c.id}`)}
                  className="table-row cursor-pointer" style={{ borderBottom: "1px solid var(--border)" }}>
                <td className="py-2.5 px-3 font-mono text-[11.5px]" style={{ color: "var(--text-secondary)" }}>{c.case_ref}</td>
                <td className="py-2.5 px-3 max-w-[340px] truncate" title={c.title}>{c.title}</td>
                <td className="py-2.5 px-3">{c.customer_name}</td>
                <td className="py-2.5 px-3"><span className={`badge ${RISK_CLASS[c.risk_type]}`}>{RISK_LABEL[c.risk_type]}</span></td>
                <td className="py-2.5 px-3"><span className="badge b-muted">{CATEGORY_LABEL[c.category] || c.category || "—"}</span></td>
                <td className="py-2.5 px-3"><span className="badge b-muted">{c.status}</span></td>
                <td className="py-2.5 px-3 font-mono">{c.attention_score}</td>
                <td className="py-2.5 px-3 text-[11.5px]" style={{ color: "var(--text-muted)" }}>{fmtTimeAgo(c.sla_deadline)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
